var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendButtonV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#500D76"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5702 9.43131L15.2762 16.7237M17.6909 22.4563C17.7163 22.5194 17.7603 22.5732 17.8171 22.6106C17.8739 22.648 17.9408 22.6671 18.0088 22.6653C18.0768 22.6636 18.1427 22.6411 18.1975 22.6009C18.2524 22.5606 18.2936 22.5046 18.3156 22.4403L22.6493 9.77404C22.6707 9.71497 22.6748 9.65105 22.6611 9.58975C22.6474 9.52845 22.6166 9.47231 22.5721 9.4279C22.5277 9.38349 22.4716 9.35265 22.4103 9.33898C22.349 9.32531 22.285 9.32938 22.226 9.35072L9.55823 13.6839C9.49389 13.706 9.43784 13.7472 9.3976 13.802C9.35736 13.8568 9.33486 13.9227 9.33312 13.9907C9.33138 14.0587 9.35048 14.1255 9.38785 14.1824C9.42523 14.2392 9.4791 14.2832 9.54223 14.3085L14.8293 16.4285C14.9965 16.4954 15.1483 16.5954 15.2758 16.7226C15.4032 16.8498 15.5035 17.0014 15.5707 17.1684L17.6909 22.4563Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_9678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButtonV);
export default __webpack_public_path__ + "static/media/send-button-v.39eaa286b32f3a150289eeb858fc9bcd.svg";
export { ForwardRef as ReactComponent };